@if (darkTheme) {
    <div class="sew-theme-dark">
        <sew-headline level="4" no-margin>{{ title }}</sew-headline>
    </div>
}
@if (!darkTheme) {
    <sew-headline level="4" no-margin>{{ title }}</sew-headline>
}

<osc-caas-monday-webforms
    #caasMondayWebforms
    [formularPath]="'blog-subscription'"
    [ws]="true"
    [darkTheme]="darkTheme"
    [buttonFullWidth]="true"
    [noMargin]="true"
    [noGrid]="true"
    [createFormControl]="createFormControl"
    (submitForm)="onSubmit($event)"
    (title)="onGetTitle($event)"
    (mac)="onGetMac($event)"
    (actionChange)="setActionType($event)"
></osc-caas-monday-webforms>

<sew-dialog
    [closeButton]="true"
    [attr.open]="displaySuccessDialog ? true : null"
    size="xs"
    type="error"
    (close)="closeDialog()"
>
    <!-- empty headline for styling -->
    <sew-headline level="3"></sew-headline>
    @if (action?.type === ActionType.MARKETO_ACTION) {
        <p>{{ labels?.subscribeSuccessMessageMarketo }}</p>
    }
    @if (action?.type === ActionType.SEW_MAIL_ACTION) {
        <p>{{ labels?.subscribeSuccessMessageMail }}</p>
    }
    <sew-ws-button slot="button" hierarchy="primary"
        ><button (click)="closeDialog()">{{ labels?.confirm }}</button></sew-ws-button
    >
</sew-dialog>

<sew-dialog
    [closeButton]="true"
    [attr.open]="displayErrorDialog ? true : null"
    size="xs"
    type="error"
    (close)="closeDialog()"
>
    <!-- empty headline for styling -->
    <sew-headline level="3"></sew-headline>
    <p>{{ labels?.subscribeErrorMessage }}</p>
    <sew-ws-button slot="button" hierarchy="primary"
        ><button (click)="closeDialog()">{{ labels?.confirm }}</button></sew-ws-button
    >
</sew-dialog>
